import React from 'react'
import { Route } from 'react-router-dom'
import { OrgSso } from './page/org-sso'
import { OrgConnectionWorkspace } from './page/org-connection-workspace'

// The organization's Authentication page, and under it one connection's own
// page (its BreadcrumbView nests under the page's "Authentication").
export const LayoutSso = () => {
  return (
    <React.Fragment>
      <Route path="/org/sso" component={OrgSso} />
      <Route path="/org/sso/connections/:providerID(\d+)" component={OrgConnectionWorkspace} />
    </React.Fragment>
  )
}
